import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import MenuItem from '@mui/material/MenuItem';
import JSI from '../../images/JSI.png';
import logOut from '../../images/LogOut.svg';
import personIcon from '../../images/person_outline.svg';
import HelpIcon from '../../images/help_outline.svg';
import AddIcon from '../../images/add.svg';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/auth/AuthContext';
import ProjectContext from '../../context/project/ProjectContext';
import { IAuthContext } from '../../types/AuthState';
import { signOut } from '../../oauth';
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';

const pages = ['Create New Project', 'Help', 'Logout'];

function NavBar() {
  const navigate = useNavigate();
  const projectContext = useContext(ProjectContext);
  const authContext = useContext<IAuthContext>(AuthContext);
  let { user } = authContext;
  const { intelliFiberUserRoles } = projectContext;
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log('$$$USER :', user);
      console.log('$$$All USER Roles:', intelliFiberUserRoles);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log('$$$USER Role:', role);
      if (role) {
        return role.RoleName ? role.RoleName : '';
      }
    }
    return '';
  };

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleLogout = async () => {
    await signOut();
  };

  const showNewProject = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    navigate('/new-project');
  };

  const generateAPIToken = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    //generate Token
  };
  const goHomePage = () => navigate('/');
  const goConfigPage = () => navigate('/config/roles');
  return (
    <AppBar position='static' style={{ backgroundColor: '#366aaf' }}>
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          <IconButton
            className='nav-bar__logo__img'
            sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}
          >
            <Link id='HomeLink' to='/'>
              <img src={JSI} alt='Logo' />{' '}
            </Link>
          </IconButton>

          <Typography
            variant='h6'
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              flexGrow: 1,
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Intelli-Fiber
          </Typography>

          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign='center'>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* <IconButton sx={{ display: { xs: "flex", md: "none" }, mr: 1, p: 0 }}>
            <Link id='mbHomeLink' to='/'>
              <Avatar alt='Logo' src={JSI} />
            </Link>
          </IconButton> */}

          {/* <Typography
            variant='h5'
            noWrap
            component='a'
            href=''
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <Button>
              <Link id='projectHome' to='/project/details'>
                Intelli-Fiber
              </Link>
            </Button>
          </Typography> */}
          <Box sx={{ flexGrow: 0, p: 0, ml: 2 }}>
            {getUserRoleType() === 'Central GIS Team' && (
              <MenuItem
                sx={{ display: { xs: 'none', md: 'flex' }, p: 0, my: 1 }}
                className='nav-bar__menu__create_button'
              >
                <Button
                  //sx={{ backgroundColor: 'white', p: 1, mx: 2 }}
                  onClick={showNewProject}
                >
                  <img
                    src={AddIcon}
                    alt='Create New Project'
                    className='nav-bar__menu__button_icon'
                  />
                  Create New Project
                </Button>
              </MenuItem>
            )}
          </Box>
          <Box sx={{ flexGrow: 0, p: 0, ml: 2 }}>
            <IconButton>
              <HomeIcon
                onClick={goHomePage}
                sx={{ color: 'white' }}
                fontSize='large'
              />
            </IconButton>
          </Box>
          {getUserRoleType() === 'Central GIS Team' && (
            <Box sx={{ flexGrow: 0, p: 0, ml: 2 }}>
              <IconButton>
                <SettingsIcon
                  onClick={goConfigPage}
                  sx={{ color: 'white' }}
                  fontSize='large'
                />
              </IconButton>
            </Box>
          )}
          <Box sx={{ flexGrow: 0, p: 0, ml: 2 }}>
            <MenuItem className='nav-bar__menu__item nav-bar__menu__group'>
              <div>
                <img
                  src={personIcon}
                  alt='user'
                  className='nav-bar__menu__icon'
                />
              </div>
              <div>
                <div>{`${user?.userName}`}</div>
                <div className='nav-bar__menu__dropdown2__toggle__sub-title'>
                  {user?.role}
                </div>
              </div>
            </MenuItem>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, p: 0, my: 1 }}>
            <MenuItem>
              <img src={HelpIcon} alt='Help' />
            </MenuItem>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              flexGrow: 0,
              p: 0,
              ml: 2,
            }}
          >
            <MenuItem onClick={handleLogout}>
              <img src={logOut} alt='log out' />
            </MenuItem>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;
